String.prototype.replaceAt = function (index, replacement) {
  return this.substring(0, index) + replacement + this.substring(index + replacement.length);
};

export const roundMoment = (mom, precision, key, direction) => {
  if (typeof direction === "undefined") {
    direction = "round";
  }

  var keys = ["Hours", "Minutes", "Seconds", "Milliseconds"];
  var maxValues = [24, 60, 60, 1000];

  // Capitalize first letter
  key = key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();

  // make sure key is plural
  if (key.indexOf("s", key.length - 1) === -1) {
    key += "s";
  }
  var value = 0;
  var rounded = false;
  var subRatio = 1;
  var maxValue;
  for (var i in keys) {
    var k = keys[i];
    if (k === key) {
      value = mom._d["get" + key]();
      maxValue = maxValues[i];
      rounded = true;
    } else if (rounded) {
      subRatio *= maxValues[i];
      value += mom._d["get" + k]() / subRatio;
      mom._d["set" + k](0);
    }
  }

  value = Math[direction](value / precision) * precision;
  value = Math.min(value, maxValue);
  mom._d["set" + key](value);

  return mom;
};

export const QRCodeReader = () => {
  let listener = undefined;
  let currentReading = "";
  let resetId;
  let isListening = false;

  const eventKeyUp = event => {
    if (event.code === "Enter" && currentReading) {
      clearTimeout(resetId);
      if (currentReading.length === 36) {
        currentReading = currentReading.replaceAt(8, "-");
        currentReading = currentReading.replaceAt(13, "-");
        currentReading = currentReading.replaceAt(18, "-");
        currentReading = currentReading.replaceAt(23, "-");
        currentReading += "::";
      }

      // Ephemeral format v2
      if (currentReading.split(":/").length > 1) currentReading = currentReading.split(":/")[0];
      if (currentReading && listener) listener(currentReading);
      currentReading = "";
    }

    clearTimeout(resetId);

    if (event.code !== "ShiftLeft") {
      let key = event.key.toLowerCase();
      if (event.code.startsWith("Digit")) key = event.code.split("Digit")[1];
      currentReading = currentReading + key;
    }
    resetId = setTimeout(() => {
      currentReading = "";
    }, 200);
  };

  return {
    start: () => {
      if (isListening) return;
      isListening = true;
      window.document.addEventListener("keyup", eventKeyUp);
    },
    stop: () => {
      clearTimeout(resetId);
      isListening = false;
      window.document.removeEventListener("keyup", eventKeyUp);
    },
    setListener: lst => {
      listener = lst;
    },
    clearListener: () => {
      listener = undefined;
    },
  };
};

export const visitorMatchSearch = (visitor, search) => {
  return (
    (visitor.lastname + " " + visitor.firstname)
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toUpperCase()
      .indexOf(search.toUpperCase()) > -1
  );
};

export const QRCODE = {
  TYPES: {
    UNKNOWN: "UNKNOWN",
    VISITOR_OUTDATED_VISIT: "VISITOR_OUTDATED_VISIT",
    VISITOR_UPCOMING_VISIT: "VISITOR_UPCOMING_VISIT",
    VISITOR_TODAY_VISIT: "VISITOR_TODAY_VISIT",
    VISITOR_WITHOUT_VISIT: "VISITOR_WITHOUT_VISIT",
    RESIDENT: "RESIDENT_EPHEMERAL_CODE",
    BADGE: "BADGE",
    OUTDATED: "OUTDATED",
  },
};

export const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms));
